'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.bonuses = void 0;
var adapter_1 = require("../adapter");
var Bonuses = /** @class */ (function () {
    function Bonuses() {
    }
    /**
     * Credit user with a bonus
     */
    Bonuses.prototype.credit = function (userID, code) {
        var params = { userID: userID, code: code };
        return adapter_1.adapter.bonuses.credit(params);
    };
    return Bonuses;
}());
exports.bonuses = new Bonuses();
